export interface IMailTemplateAttachment {
  id?: number;
  attachmentContentType?: string;
  attachment?: any;
  mailTemplateSubject?: string;
  mailTemplateId?: number;
}

export const defaultValue: Readonly<IMailTemplateAttachment> = {};
